<template>
    <div class="flex justify-center w-full">
        <div class="w-full mx-4 sm:w-[520px] mt-32 sm:mt-32 pb-16">
            <!--
            Depending on the logo, you may need to adjust the width of the <img> element. For a
            logo like Daybreak's, a width of 260px is usually good. For something like a Side
            Quest logo that's just text, a width of about 340px seems to work well.

            You also may need to adjust the positioning of the logo. If the logo should overlap
            the background of the page, then use the <img> that's outside the <div>. If the logo
            should be whole contained within the container, use the <img> that's inside the <div>.
            For whichever logo you don't use, make sure to comment that out so it doesn't render.

            If the logo should overlap the background, use a negative top margin to pull the container
            up behind the logo. Also use a larger top padding to push the content within the container
            down to make room for the logo. Typically, using a difference of 4 units will get you what
            you want (if you're using `-mt-16`, then use `pt-20`).

            If the logo shouldn't overlap the background and be a part of the content within the
            container, then remove the negative top margin and set the top padding to a less extreme
            value, like `pt-8`.
            -->
            <!-- <img v-if="campaign.logo_url != null" v-bind:src="campaign.logo_url" class="w-[340px] m-auto"> -->

            <div class="flex flex-col bg-dark-blue rounded-lg p-6 pt-8 gap-y-6" v-bind="$attrs">
                <img v-if="campaign.logo_url != null" v-bind:src="campaign.logo_url" class="-mt-16 -mb-4 w-[280px] m-auto">

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
defineProps({
    campaign: Object,
    dtd: Boolean
});
</script>
